'use strict';

angular.module('adelementAdminApp')
	.controller('RoleMappingDeleteController', function($scope, $uibModalInstance, entity, RoleMapping) {

        $scope.roleMapping = entity;
        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.confirmDelete = function (id) {
            RoleMapping.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    });
